import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'
import KeenSlider from 'keen-slider'
import { prepareSlides, initSliderWrapper } from '@/lib/keen-slider.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { sliderElement } = zelektor(node)


    /*******************************************************************************************************************************************/
    /* Slider
    /*******************************************************************************************************************************************/
    prepareSlides(sliderElement)

    let autoplay

    const slider = new KeenSlider(sliderElement, {
        slidesPerView: 7,
        loop: true,
        mode: 'free',
        duration: 800,
        breakpoints: {
            '(max-width: 1024px)': {
                slidesPerView: 5.5
            },
            '(max-width: 768px)': {
                slidesPerView: 3.5
            },
            '(max-width: 512px)': {
                slidesPerView: 2,
                centered: true
            }
        },
        created: slider => {
            autoplay = setAutoPlay(slider)
        },
        dragStart: () => {
            clearInterval(autoplay)
        }
    })


    /*******************************************************************************************************************************************/
    /* Slider Autoplay
    /*******************************************************************************************************************************************/
    function setAutoPlay(slider) {
        return setInterval(() => {
            const sliderData = slider.details()
            slider.moveToSlide(sliderData.relativeSlide + 1)
        }, 2000)
    }

    
    /*******************************************************************************************************************************************/
    /* Destroy / Restore slider + Autoplay based on window width
    /*******************************************************************************************************************************************/
    let currentWidth = window.innerWidth > 1024 ? 'large' : 'small'
    
    if (currentWidth === 'large') {
        destroySlider(slider)
        clearInterval(autoplay)
    }

    window.addEventListener('resize', handleWindowResize)

    function handleWindowResize() {
        if (window.innerWidth > 1024 && currentWidth === 'small') {
            destroySlider(slider)
            clearInterval(autoplay)
            currentWidth = 'large'
        }

        if (window.innerWidth <= 1024 && currentWidth === 'large') {
            restoreSlider(slider)
            autoplay = setAutoPlay(slider)
            currentWidth = 'small'
        }
    }

    function destroySlider(slider) {
        slider.destroy()
    }

    function restoreSlider(slider) {
        slider.refresh()
    }
})